import script from "./OTPInputForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTPInputForm.vue?vue&type=script&lang=ts&setup=true"

import "./OTPInputForm.vue?vue&type=style&index=0&id=61ed4237&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ed4237"]])

export default __exports__